import * as React from 'react';
import dayjs from 'dayjs';
import { Page, Card } from 'tabler-react';
import { Link } from 'react-router-dom';
import PageComponent from '../PageComponent';
import store from '../../shared/store';
import Request from '../../shared/request';
import './bind.scss';
import i18n from '../../shared/i18n';

const DEVICE_MAP = {
  'android-tv': 'Android TV',
  chrome: 'Chrome',
  ios: 'iOS',
  android: 'Android',
  mac: 'macOS',
  windows: 'Windows',
};
class BindIndex extends PageComponent {
  state = {
    devices: [],
    loading: '',
  };

  componentDidMount() {
    this.getDevices();
  }

  getDevices = async () => {
    const devices = await Request.call('getDevices');
    if (devices) {
      this.setState({ devices });
    }
  };

  unbind = async deviceId => {
    this.setState({ loading: deviceId });
    const devices = await Request.call('unbindDevice', { deviceId });
    if (devices) {
      this.setState({ devices });
    }
    this.setState({ loading: '' });
  };

  goVas = () => {
    this.props.history.push('/dashboard/vas?planId=device_2');
  };

  getLeave = () => {
    if (this.state.devices) {
      const num = store.user.clients - this.getUsed();
      return num > 0 ? num : 0;
    }
    return '-';
  };

  getUsed = () =>
    this.state.devices.some(d => d.app === 'chrome')
      ? this.state.devices.length - 1
      : this.state.devices.length;

  render() {
    return (
      <Page.Content className="page-bind">
        <Card>
          <Card.Header>
            <Link to="/dashboard">
              <i className="fa fa-angle-left" />
              <span>{i18n.t('dash-btn-back')}</span>
            </Link>
            <Card.Title>{i18n.t('dash-device-title')}</Card.Title>
          </Card.Header>
          <div className="content">
            <div className="header">
              <div className="num">
                {i18n.t('dash-device-title')}
                <span className="color"> {i18n.t('dash-device-used')}: {this.getUsed()} </span>
                <span> {i18n.t('dash-device-left')}: {this.getLeave()}</span>
              </div>
              <div className="btn-vas" onClick={this.goVas}>
              {i18n.t('dash-vas-device')}
              </div>
            </div>
            <div className="body">
              {this.state.devices
                .filter(d => d.app === 'chrome')
                .map((device, i) => (
                  <div className={"item-device" + ' ' + `${device.app}`}>
                    <div className="icon">
                      <i className="ri-macbook-line" />
                    </div>
                    <div className="middle">
                      <div className="name">
                        <div>{DEVICE_MAP[device.app]}:{device.version}</div>
                        <span className="tags"> {i === 0 ? i18n.t('dash-device-free'): ''}</span>
                      </div>
                      <div className="time">
                        <span>{i18n.t('dash-device-last')}: </span>
                        <span>
                          {dayjs(device.lastUpdateAt).format(
                            'YYYY.MM.DD HH:mm',
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="right">
                      <div
                        className="btn-unbind"
                        onClick={() => this.unbind(device._id)}>
                        {this.state.loading === device._id
                          ? i18n.t('dash-device-unbinding')
                          : i18n.t('dash-device-unbind')}
                      </div>
                    </div>
                  </div>
                ))}
              {this.state.devices
                .filter(v => v.app !== 'chrome')
                .map(device => (
                  <div className={"item-device" + ' ' + `${device.app}`}>
                    <div className="icon">
                      <i className="ri-macbook-line" />
                    </div>
                    <div className="middle">
                      <div className="name">
                        {DEVICE_MAP[device.app]}:{device.version}
                      </div>
                      <div className="time">
                        <span>{i18n.t('dash-device-last')}: </span>
                        <span>
                          {dayjs(device.lastUpdateAt).format(
                            'YYYY.MM.DD HH:mm',
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="right">
                      <div
                        className="btn-unbind"
                        onClick={() => this.unbind(device._id)}>
                        {this.state.loading === device._id
                          ? i18n.t('dash-device-unbinding')
                          : i18n.t('dash-device-unbind')}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="footer">
              {i18n.t('dash-device-rule')}
            </div>
          </div>
        </Card>
      </Page.Content>
    );
  }
}

export default BindIndex;
